import echartsCity from "./src/city.vue";

echartsCity.install = function(Vue) {
  Vue.component(echartsCity.name, echartsCity);
};

export default echartsCity;
